import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { hsla2rgba as t, isNamedColor as r, getNamedColor as s } from "./colorUtils.js";
import { clamp as i } from "./core/mathUtils.js";
import { isSome as e } from "./core/maybe.js";
import { ensureInteger as n } from "./core/accessorSupport/ensureType.js";

function a(t) {
  return i(n(t), 0, 255);
}

function o(t, r, s) {
  return t = Number(t), isNaN(t) ? s : t < r ? r : t > s ? s : t;
}

var h = /*#__PURE__*/function () {
  function h(t) {
    _classCallCheck(this, h);

    this.r = 255, this.g = 255, this.b = 255, this.a = 1, t && this.setColor(t);
  }

  _createClass(h, [{
    key: "isBright",
    get: function get() {
      return .299 * this.r + .587 * this.g + .114 * this.b >= 127;
    }
  }, {
    key: "setColor",
    value: function setColor(t) {
      if ("string" == typeof t) h.fromString(t, this);else if (Array.isArray(t)) h.fromArray(t, this);else {
        var r, s, i, e;
        this._set(null != (r = t.r) ? r : 0, null != (s = t.g) ? s : 0, null != (i = t.b) ? i : 0, null != (e = t.a) ? e : 1), t instanceof h || this._sanitize();
      }
      return this;
    }
  }, {
    key: "toRgb",
    value: function toRgb() {
      return [this.r, this.g, this.b];
    }
  }, {
    key: "toRgba",
    value: function toRgba() {
      return [this.r, this.g, this.b, this.a];
    }
  }, {
    key: "toHex",
    value: function toHex() {
      var t = this.r.toString(16),
          r = this.g.toString(16),
          s = this.b.toString(16);
      return "#".concat(t.length < 2 ? "0" + t : t).concat(r.length < 2 ? "0" + r : r).concat(s.length < 2 ? "0" + s : s);
    }
  }, {
    key: "toCss",
    value: function toCss() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var r = this.r + ", " + this.g + ", " + this.b;
      return t ? "rgba(".concat(r, ", ").concat(this.a, ")") : "rgb(".concat(r, ")");
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.toCss(!0);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toArray();
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var r = a(this.r),
          s = a(this.g),
          i = a(this.b);
      return 0 === t || 1 !== this.a ? [r, s, i, a(255 * this.a)] : [r, s, i];
    }
  }, {
    key: "clone",
    value: function clone() {
      return new h(this.toRgba());
    }
  }, {
    key: "hash",
    value: function hash() {
      return this.r << 24 | this.g << 16 | this.b << 8 | 255 * this.a;
    }
  }, {
    key: "_sanitize",
    value: function _sanitize() {
      return this.r = Math.round(o(this.r, 0, 255)), this.g = Math.round(o(this.g, 0, 255)), this.b = Math.round(o(this.b, 0, 255)), this.a = o(this.a, 0, 1), this;
    }
  }, {
    key: "_set",
    value: function _set(t, r, s, i) {
      this.r = t, this.g = r, this.b = s, this.a = i;
    }
  }], [{
    key: "blendColors",
    value: function blendColors(t, r, s) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new h();
      return i.r = Math.round(t.r + (r.r - t.r) * s), i.g = Math.round(t.g + (r.g - t.g) * s), i.b = Math.round(t.b + (r.b - t.b) * s), i.a = t.a + (r.a - t.a) * s, i._sanitize();
    }
  }, {
    key: "fromRgb",
    value: function fromRgb(r, s) {
      var i = r.toLowerCase().match(/^(rgba?|hsla?)\(([\s\.\-,%0-9]+)\)/);

      if (i) {
        var _r = i[2].split(/\s*,\s*/),
            _e = i[1];

        if ("rgb" === _e && 3 === _r.length || "rgba" === _e && 4 === _r.length) {
          var _t = _r[0];

          if ("%" === _t.charAt(_t.length - 1)) {
            var _t2 = _r.map(function (t) {
              return 2.56 * parseFloat(t);
            });

            return 4 === _r.length && (_t2[3] = parseFloat(_r[3])), h.fromArray(_t2, s);
          }

          return h.fromArray(_r.map(function (t) {
            return parseFloat(t);
          }), s);
        }

        if ("hsl" === _e && 3 === _r.length || "hsla" === _e && 4 === _r.length) return h.fromArray(t(parseFloat(_r[0]), parseFloat(_r[1]) / 100, parseFloat(_r[2]) / 100, parseFloat(_r[3])), s);
      }

      return null;
    }
  }, {
    key: "fromHex",
    value: function fromHex(t) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new h();
      if (4 !== t.length && 7 !== t.length || "#" !== t[0]) return null;
      var s = 4 === t.length ? 4 : 8,
          i = (1 << s) - 1;
      var e = Number("0x" + t.substr(1));
      return isNaN(e) ? null : (["b", "g", "r"].forEach(function (t) {
        var n = e & i;
        e >>= s, r[t] = 4 === s ? 17 * n : n;
      }), r.a = 1, r);
    }
  }, {
    key: "fromArray",
    value: function fromArray(t) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new h();
      return r._set(Number(t[0]), Number(t[1]), Number(t[2]), Number(t[3])), isNaN(r.a) && (r.a = 1), r._sanitize();
    }
  }, {
    key: "fromString",
    value: function fromString(t, i) {
      var e = r(t) ? s(t) : null;
      return e && h.fromArray(e, i) || h.fromRgb(t, i) || h.fromHex(t, i);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(t) {
      return t && new h([t[0], t[1], t[2], t[3] / 255]);
    }
  }, {
    key: "toUnitRGB",
    value: function toUnitRGB(t) {
      return e(t) ? [t.r / 255, t.g / 255, t.b / 255] : null;
    }
  }, {
    key: "toUnitRGBA",
    value: function toUnitRGBA(t) {
      return e(t) ? [t.r / 255, t.g / 255, t.b / 255, null != t.a ? t.a : 1] : null;
    }
  }]);

  return h;
}();

h.prototype.declaredClass = "esri.Color";
export { h as default };